import { useState } from 'react';

export interface UseActiveMenuReturn {
  /**
   * Active menu ID
   */
  activeMenuID?: string;
  /**
   * Function to toggle the active menu. Accepts ID.
   */
  setActiveMenuID?: (id: string) => void;
}

/**
 * Custom hook to toggle the `HeaderNavigation` active overlay.
 * @returns @see {@link UseActiveMenuReturn};
 */
export function useActiveMenu(): UseActiveMenuReturn {
  const [activeMenuID, setActiveID] = useState('');
  const handleActiveMenuToggle = (id: string): void => setActiveID(activeMenuID === id ? '' : id);
  return { activeMenuID, setActiveMenuID: handleActiveMenuToggle };
}
